<template>
  <div>
    <v-autocomplete
      v-model="state"
      :items="recruitmentStates"
      item-value="id"
      item-text="name"
      :label="$t('recruitment_request.state')"
      outlined
      dense
      :color="inputColor"
      :background-color="backgroundColor"
      hide-details
      clearable
      @input="$emit('input', state)"
    ></v-autocomplete>

    <input type="hidden" />
  </div>
</template>

<script>
import useSharedSelectData from "@/use/SharedSelectData.js";
import useSharedData from "@/use/SharedData";
import {ref} from "vue";

export default {
  props: {
    value: {
      type: String,
      default: () => {
        return null;
      },
    },
  },
  name: "StrRecruitmentStateAutocomplete",
  setup() {
    const {recruitmentStates} = useSharedSelectData();
    const {inputColor, backgroundColor} = useSharedData();
    const state = ref(null);

    return {
      state,
      recruitmentStates,
      inputColor,
      backgroundColor
    }
  },
}
</script>

<style scoped>

</style>